module.exports = "/static/assets/a12e5ce6042183e13ac302e565f0eaff.png";